import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { changeLanguage } from "../i18n";
import type { LanguageContextType } from "../types";
import AsyncStorage from "@react-native-async-storage/async-storage";

const DEFAULT_LANGUAGE = "en-US";
const LANGUAGE_STORAGE_KEY = "@wizewings:lang";
const availableLanguages = ["en-US", "pt-BR"];

function LanguageProvider(props: React.PropsWithChildren<unknown>) {
  const [loadingLanguage, setLoadingLanguage] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(DEFAULT_LANGUAGE);

  useEffect(() => {
    (async function () {
      const savedLanguage = await AsyncStorage.getItem(LANGUAGE_STORAGE_KEY);
      const initialLanguage = availableLanguages.includes(savedLanguage || "")
        ? savedLanguage || DEFAULT_LANGUAGE
        : DEFAULT_LANGUAGE;

      changeLanguage(initialLanguage);
      setCurrentLanguage(initialLanguage);
    })();
  }, []);

  const toggleLanguage = (aLang: string) => {
    // alert("entrou");
    setLoadingLanguage(true);
    changeLanguage(aLang);
    setCurrentLanguage(aLang);

    setTimeout(() => setLoadingLanguage(false), 500);
    return;
  };

  return (
    <LanguageContext.Provider
      value={{
        toggleLanguage,
        loadingLanguage,
        currentLanguage,
      }}
      {...props}
    />
  );
}

const LanguageContext = createContext<LanguageContextType>({
  loadingLanguage: false,
  currentLanguage: DEFAULT_LANGUAGE,
} as LanguageContextType);
const useLanguage = () => useContext(LanguageContext);

export { LanguageProvider, useLanguage };
